export default ($wire, { modalEventName, hideOverflow = true }) => ({
    isOpen: false,
    init() {
        window.addEventListener(modalEventName, event => {
            event.detail === 'open' ? this.open() : this.close();
            this.toggleSourcePage(event);
        });
    },
    open() {
        this.isOpen = true;

        if (hideOverflow) {
            document.body.style.overflow = 'hidden';
        }
    },
    close() {
        this.isOpen = false;
        document.body.style.overflow = 'auto';
    },
    toggleSourcePage(data) {
        let sourcePage = 'listing_detail';

        if (data.detail.isOpen) {
            data.detail.isOpen === 'open' ? this.open() : this.close();
            sourcePage = data.detail.sourcePage;
            $wire.dispatch('setUrl', {
                validationUrl: window.location.host,
                protocol: window.location.protocol + '//',
            });
        }

        $wire.dispatch('changeSourcePage', [sourcePage]);
    },
});
